import { useQuery } from 'react-query';
import RestHttpClient from '../../../common/RestHttpClient';

export const dashboardApplicationsQueryKey = (showAll: boolean, applicationState?: number) =>
  ['dashboard', 'applications', showAll, applicationState] as const;

export function useApplicationsQuery(showAll: boolean, applicationState?: number) {
  return useQuery({
    queryKey: dashboardApplicationsQueryKey(showAll, applicationState),
    queryFn: async () => {
      const { data } = await RestHttpClient.getApplications(showAll, applicationState);
      return data;
    },
    keepPreviousData: true,
    staleTime: 60_000,
  });
}
